const QrIcon = () => {
  return (
    <svg
      className="header_icon"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <rect className="fill" x="17" y="17" width="6" height="6" rx="1" fill="#17171C" />
      <rect className="fill" x="25" y="17" width="6" height="6" rx="1" fill="#17171C" />
      <rect className="fill" x="17" y="25" width="6" height="6" rx="1" fill="#17171C" />
      <mask id="path-5-inside-1_692_2842" fill="white">
        <rect x="25" y="25" width="6" height="6" rx="1" />
      </mask>
      <rect
        className="stroke"
        x="25"
        y="25"
        width="6"
        height="6"
        rx="1"
        stroke="#17171C"
        strokeWidth="4"
        mask="url(#path-5-inside-1_692_2842)"
      />
      <path
        className="stroke"
        d="M28.5 14H31C32.6569 14 34 15.3431 34 17V19.5"
        stroke="#17171C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        className="stroke"
        d="M28.5 34H31C32.6569 34 34 32.6569 34 31V28.5"
        stroke="#17171C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        className="stroke"
        d="M19.5 14H17C15.3431 14 14 15.3431 14 17V19.5"
        stroke="#17171C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        className="stroke"
        d="M19.5 34H17C15.3431 34 14 32.6569 14 31V28.5"
        stroke="#17171C"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default QrIcon
